import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	overdueLabel: {
		id: 'business-calendar.calendar-view.calendar-issue.overdue-label',
		defaultMessage: 'Overdue',
		description: 'Label for overdue issues',
	},
	doneLabel: {
		id: 'business-calendar.calendar-view.calendar-issue.done-label',
		defaultMessage: 'Done',
		description: 'Label for done issues',
	},
});
